import { Subscription, SubscriptionMobileDeviceById } from 'graphql/generated/graphqlTypes';
import { generateMockSubscriptionMobileDeviceRegistered } from 'mocks/graphqlMocks/subscriptionMobileDeviceRegistered';

export function mockedOnMobileDeviceRegisteredData(
  onMobileDeviceRegisteredById: SubscriptionMobileDeviceById | null
): Pick<Subscription, 'onMobileDeviceRegisteredById'> {
  return {
    onMobileDeviceRegisteredById
  };
}

export const mockedOnMobileDeviceRegisteredDataForSubscription = mockedOnMobileDeviceRegisteredData(
  generateMockSubscriptionMobileDeviceRegistered({})
);
